<template>
  <div class="flex-center">
    <new-product-dialog />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NewProductDialog from '@/modules/product/ProductNewDialog'
import _ from 'lodash'
export default {
  components: {
    NewProductDialog
  },
  props: {
    disabled: Boolean,
    selected: { type: Array, default: () => [] }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('product', ['products']),
    multipleAction () {
      return !_.isEmpty(this.selected)
    }
  },
  methods: {
    ...mapActions('product', ['removeProducts', 'updateProducts']),
    disableProduct () {
      this.updateProducts(
        this.selected.map(item => {
          return { ...item, status: 'block' }
        })
      )
    },
    enableProduct () {
      this.updateProducts(
        this.selected.map(item => {
          return { ...item, status: 'active' }
        })
      )
    }
  }
}
</script>
